import { useQuery, UseQueryResult } from 'react-query';
import { FlowRetrieve } from 'types';
import { client } from 'utils/api-client';

function useFlow(flowId: string | undefined | null): UseQueryResult<{ data: FlowRetrieve }> {
  return useQuery(['flows', flowId], () => client.get(`flows/${flowId}/`), {
    enabled: !!flowId,
  });
}

export default useFlow;
